import { BASE_API_URL } from '../../config';
import { get, post } from '../base';
import {
  PlanogramMediaUploadedRequest,
  PlanogramMediaUploadedResponse,
  PlanogramSignedUploadUrlResponse,
} from './reqres';

export default function PlanogramMediaService() {
  return Object.freeze({
    /**
     * Gets signed URL for uploading media to planogram
     * @param fileName - Name of the file to upload
     * @param planogramId - UUID of planogram
     */
    getSignedUploadUrl(
      fileName: string,
      planogramId: string
    ): Promise<PlanogramSignedUploadUrlResponse> {
      return get(
        `${BASE_API_URL()}/file-storage/upload-url/planogram?file=${fileName}&uuid=${planogramId}`
      );
    },

    /**
     * Notifies backend that media upload is complete
     * @param mediaData - Media upload notification data
     */
    mediaUploaded(
      mediaData: PlanogramMediaUploadedRequest
    ): Promise<PlanogramMediaUploadedResponse> {
      return post(`${BASE_API_URL()}/media/planogram/uploaded`, mediaData);
    },
  });
}
